import { useContext, useEffect, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import callAPI from '../../helpers/callAPI'
import { SystemMessageContext } from '../../context/SystemMessageContext'
import NotesLog from '../../components/NotesLog/NotesLog'

export default function AvatarNotesModal({ affiliateId, refetch, isOpen, setIsOpen }){
    
    const { showSystemMessage } = useContext(SystemMessageContext)

    return (
        <Modal show={isOpen} onHide={() => setIsOpen(false)} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Avatar Notes</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <NotesLog uri={`affiliate/avatar`} id={affiliateId} refetchNotesParent={refetch} refresh={refetch} />
            </Modal.Body>
        </Modal>
    )
}